import axios from 'axios'
import {apiUrl} from '../../../config/env.js'

export const CheckIp = (Path) => {
  return axios.post(apiUrl + '/access', {
    'path': Path
  })
}



// WEBPACK FOOTER //
// ./src/api/restrict_access/index.js